import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, Row } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import Id from "../../../components/Formatters/Id";
import IE from "../../../components/Formatters/IE";
import FileDownloader from "../../../components/UI/Button/FileDownloader";

const DetalheParteServico = (id) => {
  const [dados, setDados] = useState({});
  const [semDados, setSemDados] = useState(false);
  const [parteServico, setParteServico] = useState({});
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    setParteServico(id);
  }, [id]);

  useEffect(() => {
    if (parteServico?.id > 0) {
      const params = { NumParteServico: Number(parteServico.id) };
      request(apiRoutes.fiscalizacao.parteservico.listaParteServico, params);
    }
  }, [parteServico.id, request]);

  useEffect(() => {
    if ((!data && !errors) || isLoading) return;

    if (data) {
      setDados(data.result[0]);
      setSemDados(false);
    }

    if (!data) {
      setSemDados(true);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading]);

  return (
    <>
      {/* Cabeçalho da Página */}
      <div className="row">
        <div className="col-lg-12">
          {!semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <Col sm="12" className="d-flex">
                    <h5 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                      Parte Serviço nº {parteServico.id}
                    </h5>
                    <FileDownloader
                      binario={dados.documento}
                      tooltip={
                        dados.documento == null
                          ? "Sem documento cadastrado"
                          : `Visualizar parte serviço ${parteServico.id}`
                      }
                      className="ml-2"
                      nomeArquivo={`parte-servico-${parteServico.id}.pdf`}
                      disabled={dados.documento == null}
                    />
                  </Col>
                  <Col sm="1" className="text-right" />
                </Row>
              </div>
              <div className="card-body">
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Razão Social
                    <br />
                    <b>{dados.txNmFormal}</b>
                  </Col>
                  <Col sm="5">
                    CNPJ/CPF
                    <br />
                    <b>
                      <Id value={dados.nuCNPJ?.length > 0 ? dados.nuCNPJ : dados.nuCpf} />
                    </b>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Domicílio Tributário
                    <br />
                    <b>{dados.txNomeOrgao}</b>
                  </Col>
                  <Col sm="5">
                    Inscrição Estadual
                    <br />
                    <b>
                      <IE value={dados.nuIE} empty="-" />
                    </b>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <br />
                    <br />
                    <b>{dados.txTextoPadrao}</b>
                  </Col>
                </Row>

                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    <Button
                      variant="danger"
                      onClick={() => {
                        window.close();
                      }}
                    >
                      Voltar
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                    Nenhuma denúncia encontrada.
                  </h6>
                </Row>
                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    {parteServico.id == null ? (
                      <Button
                        variant="danger"
                        onClick={() => {
                          window.close();
                        }}
                      >
                        Voltar
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};

export default DetalheParteServico;
